const setting = {
  passwordTitle: "Mot de passe",
  changePasswordBtn: "Changer votre mot de passe",
  changePasswordTips:
    "Si vous avez oublié votre mot de passe ou si vous souhaitez le modifier, vous pouvez le faire ici ; nous envoyons un code de vérification à votre adresse électronique enregistrée, qui est vérifiée pour confirmer votre identité, et vous pouvez réinitialiser le mot de passe de votre compte.",
  feedbackTitle: "Commentaires",
  feedbackBtn: "Soumettre un commentaire",
  feedbackTips: "Pour nous aider à mieux vous servir, vous pouvez nous donner votre avis en décrivant votre problème ici et en le soumettant.",
  appearanceTitle: "Affichage de l'apparence",
  appearanceBtn: "Affichage du changement",
  appearanceTips:
    "Nous vous offrons le choix entre deux modes d'apparence, afin que vous puissiez passer du mode sombre au mode clair selon vos préférences.",
  changePassWordModalTitle: "Changer votre mot de passe",
  changePassWordSameErrorTips: "Entrez le nouveau mot de passe avec l'ancien, veuillez entrer un mot de passe différent",
  changePasswordCurrentErrorTips: "Le mot de passe n'est pas correct, veuillez réessayer",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  retypePasswordLabel: "Entrez à nouveau le nouveau mot de passe",
  changePasswordSuccessTips: "Votre mot de passe a été réinitialisé avec succès",
  changePasswordComfirmDiffErrorTips: "Veuillez entrer deux fois le même mot de passe",
  forgotPassword: "Vous avez oublié votre mot de passe ?",
  feedbackModalSubtitle: "Merci de nous contacter et de nous dire ce que vous pensez du produit !",
  feedBackModalProductQuestion: "Quel problème souhaitez-vous résoudre avec ce produit ?",
  feedBackModalProductTypeSug: "Suggestions",
  feedBackModalProductTypeMem: "Questions relatives aux services aux membres",
  feedBackModalProductTypeFun: "Requêtes de fonctionnalités",
  feedBackModalProductTypeReq: "Demandes de produits",
  feedBackModalProductTypeBug: "Commentaires sur les bogues des produits",
  feedBackModalProductTypeIss: "Questions de performance",
  feedBackModalProductTypeRL: "Problèmes liés à l'enregistrement et à la connexion",
  feedBackModalProductTypeRef: "Service des remboursements",
  feedBackModalProductTypeOth: "Les Autres",
  feedBackModalProductSelectQuestion: "Quel problème souhaitez-vous résoudre avec ce produit ?",
  feedBackModalProductContQuestion: "Quels problèmes avez-vous rencontrés lors de l'utilisation du produit ?",
  feedBackModalAddImageBtn: "Ajouter une image",
  feedBackModalTips: "Note:",
  feedBackModalTipsCont: "En raison du décalage horaire du service clientèle mondial, nous vous répondrons dans les 48 heures en semaine.",
  feedBackSuccessTips: "Envoyé avec succès",
  feedBackSuccessSubTips: "Nous résoudrons votre problème dans les plus brefs délais",
  feedBackFailedTips: "Échec de l'envoi",
  feedBackFailedSubTips: "Assurez-vous que votre connexion Internet fonctionne et soumettez à nouveau votre demande.",
  appearanceLightMode: "Mode d'Éclairage",
  appearanceDarkMode: "Mode Sombre",
  promotionModalTitle: "Offres",
  promoItem: "Catégorie d'offre",
  promoCode: "Code promo",
  discount: "Remises",
  applyBtn: "Appliquer",
  applyPromotionErrorTips: "Votre code promo n'est pas valide",
};

export default setting;
